var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !!_vm.firstItem
    ? _c(
        "div",
        [
          !!_vm.message.content.textMain
            ? _c("div", { staticClass: "products-list-header" }, [
                _vm._v(
                  "\n    " + _vm._s(_vm.message.content.textMain) + "\n  "
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("products-item", {
            attrs: {
              item: _vm.firstItem,
              message: _vm.message,
              "show-badge": true,
            },
            on: {
              "product-clicked": function ($event) {
                return _vm.$emit("product-clicked", $event)
              },
              "product-added-to-cart": function ($event) {
                return _vm.$emit("product-added-to-cart", $event)
              },
              "product-info-clicked": function ($event) {
                return _vm.$emit("product-info-clicked", $event)
              },
              "attribute-matching-list-expanded": function ($event) {
                return _vm.$emit("attribute-matching-list-expanded", $event)
              },
            },
          }),
          _vm._v(" "),
          !!_vm.message.content.textOther && _vm.otherItems.length > 0
            ? _c("div", { staticClass: "products-list-header" }, [
                _vm._v(
                  "\n    " + _vm._s(_vm.message.content.textOther) + "\n  "
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.otherItems, function (item, index) {
            return _c("products-item", {
              key: index,
              attrs: { item: item, message: _vm.message },
              on: {
                "product-clicked": function ($event) {
                  return _vm.$emit("product-clicked", $event)
                },
                "product-added-to-cart": function ($event) {
                  return _vm.$emit("product-added-to-cart", $event)
                },
                "product-info-clicked": function ($event) {
                  return _vm.$emit("product-info-clicked", $event)
                },
                "attribute-matching-list-expanded": function ($event) {
                  return _vm.$emit("attribute-matching-list-expanded", $event)
                },
              },
            })
          }),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }